import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { DetectOSAndBrowser } from "../redux/api/DetectBroweser";
import { DEPLOYMENT_RING } from "../utils/env.config";
import axios from "axios";

export const reactPlugin = new ReactPlugin();

const defaultProperties = {
    Client_OS: DetectOSAndBrowser().OS,
    Client_Browser: DetectOSAndBrowser().Browser,
    SocialMedia_Browser : DetectOSAndBrowser().SocialMediaBrowser,
    Deployment_Ring : DEPLOYMENT_RING,
  };

const sessionId = `${Date.now()}-${Math.floor(Math.random() * 100000)}`;

export const appInsights = new ApplicationInsights({
    config: {
      connectionString: "InstrumentationKey=d413135e-cb57-4518-9d9e-137ca09ee0ca;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=8ea81954-13f6-4d20-a689-23e2150eb274",
      enableAutoRouteTracking: true,
      disableFetchTracking: false,
      disableAjaxTracking: false,
      extensions: [reactPlugin],
      enableUnhandledPromiseRejectionTracking: true
    }
  });

let currentUserId: string | null = null;         
let authenticatedUser: string | null = null;     

export const initAppInsights = async () => {
  appInsights.loadAppInsights();

  try 
  {
    const response = await axios.get("https://api.ipify.org?format=json");
    const publicIp = response.data.ip;
    setUserId(publicIp);
    setAuthenticatedUser(null); 
  } 
  catch (err) 
  {
    setUserId("anonymous");
    setAuthenticatedUser(null);
  }

  appInsights.addTelemetryInitializer((envelope) => {
    try
    {
        if (!envelope.data!.baseData) 
        {
            envelope.data!.baseData = {};
            envelope.data!.baseData!.properties = {};
        }   
    
        envelope.data!.baseData.properties = {
            ...defaultProperties,
            ...envelope.data!.baseData.properties,
            sessionId,
          }; 
    }
    catch
    {

    }
       
    envelope.tags = envelope.tags || {};
    envelope.tags["ai.cloud.role"] = "Sapiens FrontEnd";
    envelope.tags["ai.location.ip"] = currentUserId || "unknown";
    envelope.tags["ai.user.id"] = currentUserId || "unknown";
  });

  window.onerror = (message, source, lineno, colno, error) => {
    if (error) {
      appInsights.trackException({ exception: error });
    }
    return false;
  };

  window.onunhandledrejection = (event) => {
    if (event.reason) {
      appInsights.trackException({ exception: event.reason });
    }
  };

  appInsights.trackPageView({ name: "Sapiens AI- init" });
};

export const setAuthenticatedUser = (username: string | null) => {
  authenticatedUser = username;
  appInsights.setAuthenticatedUserContext(authenticatedUser || "", undefined, true);
};

export const setUserId = (userId: string) => {
  currentUserId = userId;
};

export const clearUser = () => {
  currentUserId = null;
  authenticatedUser = null;
  appInsights.clearAuthenticatedUserContext();
};
